import { render, staticRenderFns } from "./mix-grid-block.vue?vue&type=template&id=11bf1ceb&scoped=true"
import script from "./mix-grid-block.vue?vue&type=script&setup=true&lang=js"
export * from "./mix-grid-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mix-grid-block.vue?vue&type=style&index=0&id=11bf1ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf1ceb",
  null
  
)

export default component.exports